import { createStore } from "../../Boilerplate/NBoilerplateContext";
import { setGlobalStoreInstance } from "../../Boilerplate/store";

export const store = createStore({
  name: "luminai",
  // appState: createImportsSlice
});

setGlobalStoreInstance(store); // Set it globally for non-React code

export const useStore = store;
